var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container "},[_c('editor',{ref:"aceEditor",attrs:{"value":_vm.content,"width":"100%","height":"240","theme":_vm.theme,"options":{
  　　 enableBasicAutocompletion: false,
  　　 enableSnippets: true,
  　　 enableLiveAutocompletion: false,
　　   tabSize:6,
  　　 fontSize:14,
  　　 showPrintMargin:false,   //去除编辑器里的竖线
    }},on:{"init":_vm.editorInit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }